export const strings = {
  english: {
    title: 'YOUR ORDER',
    product: 'Product',
    subtotal: 'Subtotal',
    taxes: 'Taxes',
    total: 'Total',
    button: 'PLACE ORDER',
    coupon: 'Coupon ',
    couponInfo: 'can be added on the next step',
  },

  japan: {
    title: 'ご注文詳細',
    product: '注文商品',
    subtotal: '小計',
    taxes: 'Taxes',
    total: '合計',
    button: 'PLACE ORDER',
    coupon: 'Coupon ',
    couponInfo: 'can be added on the next step',
  },
};
